import { addDoc, collection } from 'firebase/firestore';
import { db } from '../services/firebase';
import type { MisconductSource, MisconductUsage, RecipeContentRejectionCode } from '../types';

function clampSeverity(value: number): number {
    return Math.min(10, Math.max(1, Math.round(value)));
}

export async function logMisconductUsage(
    userId: string,
    input: {
        severity: number;
        code: RecipeContentRejectionCode;
        source: MisconductSource;
        contentLength?: number;
    },
): Promise<void> {
    const record: Omit<MisconductUsage, 'id'> = {
        userId,
        severity: clampSeverity(input.severity),
        code: input.code,
        source: input.source,
        createdAt: new Date().toISOString(),
        ...(typeof input.contentLength === 'number' ? { contentLength: input.contentLength } : {}),
    };

    await addDoc(collection(db, 'users', userId, 'misconductUsage'), record);
}
